import { render } from "./ConfirmTravelPass.vue?vue&type=template&id=add6d3d8&scoped=true&lang=pug"
import script from "./ConfirmTravelPass.vue?vue&type=script&lang=ts"
export * from "./ConfirmTravelPass.vue?vue&type=script&lang=ts"

import "./ConfirmTravelPass.vue?vue&type=style&index=0&id=add6d3d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-add6d3d8"

export default script